class ProductPemfTimeline extends HTMLElement {
  connectedCallback() {
    this.strip = this.querySelector('.pt-strip');
    if (!this.strip) return;
    this.triggers = Array.from(this.querySelectorAll('.pt-trigger'));

    this.strip.addEventListener('click', (event) => {
      const trigger = event.target.closest('.pt-trigger');
      if (trigger) this.activate(trigger);
    });

    this.strip.addEventListener('keydown', (event) => {
      const trigger = event.target.closest('.pt-trigger');
      if (!trigger) return;
      const index = this.triggers.indexOf(trigger);
      let next = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        next = this.triggers[(index + 1) % this.triggers.length];
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        next = this.triggers[(index - 1 + this.triggers.length) % this.triggers.length];
      } else if (event.key === 'Home') {
        next = this.triggers[0];
      } else if (event.key === 'End') {
        next = this.triggers[this.triggers.length - 1];
      }

      if (next) {
        event.preventDefault();
        next.focus();
        this.activate(next);
      }
    });
  }

  panelsFor(trigger) {
    const ids = (trigger.getAttribute('aria-controls') || '').split(/\s+/).filter(Boolean);
    return ids.map((id) => this.querySelector('#' + id)).filter(Boolean);
  }

  activate(trigger) {
    const item = trigger.closest('.pt-item');

    this.triggers.forEach((t) => {
      const active = t === trigger;
      t.setAttribute('aria-expanded', String(active));
      t.setAttribute('tabindex', active ? '0' : '-1');
      const tItem = t.closest('.pt-item');
      if (tItem) tItem.removeAttribute('data-active');
      if (!active) this.panelsFor(t).forEach((p) => { p.hidden = true; });
    });

    if (item) item.setAttribute('data-active', 'true');
    this.panelsFor(trigger).forEach((p) => { p.hidden = false; });
  }
}

customElements.define('product-pemf-timeline', ProductPemfTimeline);
